import { introspectPilgrimageSession } from '#app/utils/central-session.server'
import { redirect, type LoaderFunctionArgs } from 'react-router'
import { isCentralSsoEnabled } from '@jpg/central-sso'
import { SchoolBrand, Button } from '@jpg/design-system'

/**
 * Root route: send authenticated users through role-aware landing, otherwise show login.
 *
 * Existing sessions pass through the same bridge as a fresh Auth sign-in so
 * parents reach their portal and explicitly authorized staff keep their dashboard.
 */
export async function loader(args: LoaderFunctionArgs) {
	await import('#app/utils/env.server')

	if (!isCentralSsoEnabled()) {
		return null
	}

	// Keep the public sign-in page for visitors without a central session.
	const session = await introspectPilgrimageSession(args.request)
	if (session?.email) {
		return redirect('/sso/bridge')
	}

	return null
}

export default function IndexRoute() {
	return (
		<div className="flex items-center justify-center min-h-dvh bg-gradient-to-br from-navy-950 via-navy-800 to-navy-900 p-4 overflow-y-auto">
			<div className="flex flex-col items-center gap-8 p-10 sm:p-12 bg-cream rounded-2xl shadow-2xl max-w-md w-full text-center">
				<SchoolBrand
					variant="full"
					showMotto
					horizontal={false}
					crestSize="xl"
				/>

				<div className="w-12 h-px bg-navy-200" />

				<div className="flex flex-col gap-1">
					<h1 className="font-display uppercase tracking-trajan text-2xl font-bold text-navy">
						JPG Senior Pilgrimage: Quo Vadis
					</h1>
					<p className="font-body text-sm text-navy-500">
						JPG Academy
					</p>
				</div>

				<Button
					variant="primary"
					size="lg"
					fullWidth
					onClick={() => {
						window.location.href = '/sso/bridge'
					}}
				>
					Sign in with JPG Auth
				</Button>

				<p className="font-ui text-xs text-navy-400">
					Parents: use the email address on file in FACTS to receive a sign-in link.
				</p>
			</div>
		</div>
	)
}
